import { LOCAL_STORAGE_KEYS } from '@sputnik/resources/constants'

// clearing localStorage
export const clearAllLocalStorageValues = () => {
  window.localStorage.clear()
  // This is so the local storage hooks will pick up their new reset value after clearing
  window.dispatchEvent(new StorageEvent('local-storage'))
}

const safeParseLocalStorage = (key: string) => {
  const value = window.localStorage.getItem(key)
  if (!value) {
    return value
  }
  try {
    return JSON.parse(value)
  } catch {
    return value
  }
}

const safeWriteLocalStorage = <T extends any>(key: string, value: T) => {
  window.localStorage.setItem(key, JSON.stringify(value))
}

export const getAuthIdFromStorage = () => {
  return safeParseLocalStorage(LOCAL_STORAGE_KEYS.APPLICANT_AUTH_ID)
}

export const getEmailFromStorage = () => {
  return safeParseLocalStorage(LOCAL_STORAGE_KEYS.APPLICANT_EMAIL_KEY)
}

export const setEmailInStorage = (email: string) => {
  safeWriteLocalStorage(LOCAL_STORAGE_KEYS.APPLICANT_EMAIL_KEY, email)
}

export const getEmailHashFromStorage = () => {
  return safeParseLocalStorage(LOCAL_STORAGE_KEYS.APPLICANT_EMAIL_HASH_KEY)
}

export const getTokenFromStorage = () => {
  return safeParseLocalStorage(LOCAL_STORAGE_KEYS.AUTH_STORAGE_TOKEN_KEY)
}

export const setTokenInStorage = (token: string) => {
  safeWriteLocalStorage(LOCAL_STORAGE_KEYS.AUTH_STORAGE_TOKEN_KEY, token)
}
